var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 13.2707C3.54067 13.2707 0.729004 10.459 0.729004 6.99984C0.729004 3.54067 3.54067 0.729004 6.99984 0.729004C10.459 0.729004 13.2707 3.54067 13.2707 6.99984C13.2707 10.459 10.459 13.2707 6.99984 13.2707ZM6.99984 1.604C4.02484 1.604 1.604 4.02484 1.604 6.99984C1.604 9.97484 4.02484 12.3957 6.99984 12.3957C9.97484 12.3957 12.3957 9.97484 12.3957 6.99984C12.3957 4.02484 9.97484 1.604 6.99984 1.604Z",
    fill: "#BD8F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.02067C6.76083 8.02067 6.5625 7.82234 6.5625 7.58317V4.6665C6.5625 4.42734 6.76083 4.229 7 4.229C7.23917 4.229 7.4375 4.42734 7.4375 4.6665V7.58317C7.4375 7.82234 7.23917 8.02067 7 8.02067Z",
    fill: "#BD8F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 9.91668C6.924 9.91668 6.84817 9.89918 6.77817 9.87001C6.70817 9.84085 6.644 9.80001 6.58567 9.74751C6.53317 9.68918 6.49234 9.63085 6.46317 9.55501C6.434 9.48501 6.4165 9.40918 6.4165 9.33335C6.4165 9.25751 6.434 9.18168 6.46317 9.11168C6.49234 9.04168 6.53317 8.97751 6.58567 8.91918C6.644 8.86668 6.70817 8.82585 6.77817 8.79668C6.91817 8.73835 7.0815 8.73835 7.2215 8.79668C7.2915 8.82585 7.35567 8.86668 7.414 8.91918C7.4665 8.97751 7.50734 9.04168 7.5365 9.11168C7.56567 9.18168 7.58317 9.25751 7.58317 9.33335C7.58317 9.40918 7.56567 9.48501 7.5365 9.55501C7.50734 9.63085 7.4665 9.68918 7.414 9.74751C7.35567 9.80001 7.2915 9.84085 7.2215 9.87001C7.1515 9.89918 7.07567 9.91668 6.99984 9.91668Z",
    fill: "#BD8F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnInfoIcon);
export default __webpack_public_path__ + "static/media/warn-info-icon.236d29b0bcadf575c38802de67427b42.svg";
export { ForwardRef as ReactComponent };